import { useLocation } from "react-router-dom";

import { useSessionStore } from "../../store/session-store";
import { useSelectedProductStore } from "../store/select-product-store";
import ApiFillIcon from "../assets/llmWhisperer/api-fill-icon.svg";
import LayoutIcon from "../assets/llmWhisperer/layout-icon.svg";
import ProfileSettingsIcon from "../assets/llmWhisperer/profile-settings.svg";
import DashboardIcon from "../assets/dashboard-icon.svg";

function useSideMenu() {
  const { sessionDetails } = useSessionStore();
  const { orgName } = sessionDetails;
  const location = useLocation();
  const pathPrefix = `/llm-whisperer/${orgName}`;
  const verticalsPathPrefix = `/verticals`;
  const selectedProduct = useSelectedProductStore(
    (state) => state.selectedProduct
  );

  const pageMenus =
    selectedProduct === "llm-whisperer"
      ? [
          {
            id: 1,
            mainTitle: "MANAGE",
            subMenu: [
              {
                id: 1.1,
                title: "Dashboard",
                image: DashboardIcon,
                path: `${pathPrefix}/dashboard`,
                active: location.pathname.startsWith(`${pathPrefix}/dashboard`),
              },
              {
                id: 1.2,
                title: "API Keys",
                image: ApiFillIcon,
                path: `${pathPrefix}/api-keys`,
                active: location.pathname.startsWith(`${pathPrefix}/api-keys`),
              },
              {
                id: 1.3,
                title: "Playground",
                image: LayoutIcon,
                path: `${pathPrefix}/playground`,
                active: location.pathname.startsWith(
                  `${pathPrefix}/playground`
                ),
              },
              {
                id: 1.4,
                title: "My Account",
                image: ProfileSettingsIcon,
                path: `${pathPrefix}/account`,
                active: location.pathname.startsWith(`${pathPrefix}/account`),
              },
            ],
          },
        ]
      : selectedProduct === "verticals"
      ? [
          {
            id: 1,
            mainTitle: "MANAGE",
            subMenu: [
              {
                id: 1.1,
                title: "Dashboard",
                image: DashboardIcon,
                path: `${verticalsPathPrefix}/`,
                active: location.pathname.startsWith(`${verticalsPathPrefix}/`),
              },
              {
                id: 1.2,
                title: "Subscriptions",
                image: ApiFillIcon,
                path: `${verticalsPathPrefix}/subscriptions`,
                active: location.pathname.startsWith(
                  `${verticalsPathPrefix}/subscriptions`
                ),
              },
            ],
          },
        ]
      : null;

  return pageMenus;
}

export { useSideMenu };
